import { useState } from "react";
import { authFileUrl } from "@/lib/api";

export function AuthImage({ path, className = "", alt = "", onClick }) {
  const [err, setErr] = useState(false);

  const token = typeof window !== "undefined" ? localStorage.getItem("auth_token") : null;

  if (!path || !token) {
    return <div className={`bg-zinc-900 animate-pulse ${className}`} />;
  }

  if (err) {
    return (
      <div className={`bg-zinc-900 flex items-center justify-center text-zinc-600 text-xs ${className}`}>
        IMAGE ERROR
      </div>
    );
  }

  return (
    <img
      src={authFileUrl(path)}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={() => setErr(true)}
    />
  );
}

export function AuthVideo({ path, className = "" }) {
  const token = typeof window !== "undefined" ? localStorage.getItem("auth_token") : null;

  if (!path || !token) {
    return <div className={`bg-zinc-900 animate-pulse ${className}`} />;
  }

  return <video src={authFileUrl(path)} controls className={className} />;
}
